export const getDomain = (url: string) => {
  const domainRegex = /^(?:https?:\/\/)?(?:www\.)?([^\/:?#]+)(?:[\/:?#]|$)/i;
  const matches = url.match(domainRegex);
  if (matches && matches[1]) {
    return matches[1];
  }
  return null;
};
